import { baseApi } from '@/lib/store/api/baseQuery'
import { apiEndpoints } from '@/lib/api/endpoints'
import type { PatientOrdersResponse } from '@/types/interfaces/order'

export const patientOrdersApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getPatientOrders: builder.query<PatientOrdersResponse, void>({
            query: () => apiEndpoints.orders.list,
            providesTags: ['Order'],
        }),
    }),
    overrideExisting: false,
})

export const { useGetPatientOrdersQuery } = patientOrdersApi
